$(document).ready(function () {
	$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
		var priceType = $(this).data('price-type');

		var $product = $(this).closest('[data-cart="product"]');
		$product.find('.price[data-price-type]').hide();
		$product.find('.price[data-price-type="'+priceType+'"]').show();
	});

	$(document).on('show.bs.modal', "#modal-one-click", function () {
		yaCounterReachGoal('oneclick-show');
	});
});